'use client';

import React from "react";
import {useAppDispatch, useAppSelector} from "@/lib/redux/hooks";
import {close, selectIsOpen} from "@/lib/redux/slices/menuSlice";
import MenuItem from "@/app/components/MenuItem";
import Link from "next/link";
import {AnimatePresence, motion} from "motion/react";
import {stagger} from "motion";
import LogoutMenuItem from "@/app/components/LogoutMenuItem";
import MetaMaskConnectMenuItem from "@/app/components/MetaMaskConnectMenuItem";
import SocialComponent from "@/app/components/SocialComponent";

export default function HeaderMobileMenu() {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(selectIsOpen);

    const handleClose = () => {
        dispatch(close());
    }

    const menuItems = [
        {
            text: "PROFIL",
            href: "/profile",
            type: "profile"
        }
    ];

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.2, ease: "easeInOut"}}
                    className="fixed top-(--header-height-mobile) left-0 w-full h-dvh bg-dark-03 overflow-hidden px-4 py-8"
                >
                    <div className="pb-4">
                        <nav>
                            <motion.ul
                                initial="closed"
                                animate="open"
                                exit="closed"
                                variants={{
                                    open: {
                                        transition: {delayChildren: stagger(0.1)}
                                    },
                                    closed: {
                                        transition: {delayChildren: stagger(0.05)}
                                    }
                                }}
                                className="space-y-4">
                                {menuItems.map((item, index) => (
                                    <motion.li
                                        key={item.href}
                                        variants={{
                                            open: {
                                                y: 0,
                                                opacity: 1,
                                                transition: {
                                                    y: {stiffness: 1000, velocity: -100}
                                                }
                                            },
                                            closed: {
                                                y: 20,
                                                opacity: 0,
                                                transition: {
                                                    y: {stiffness: 1000}
                                                }
                                            }
                                        }}
                                    >
                                        <Link href={item.href} onClick={handleClose} scroll={false}>
                                            <MenuItem src={'/icons/icon-account.svg'} text={item.text}/>
                                        </Link>
                                    </motion.li>
                                ))}
                            </motion.ul>
                        </nav>
                    </div>

                    <div className="pb-4 border-b border-grey-02 mb-4">
                        <nav>
                            <motion.ul
                                initial="closed"
                                animate="open"
                                exit="closed"
                                variants={{
                                    open: {
                                        transition: {delayChildren: stagger(0.1)}
                                    },
                                    closed: {
                                        transition: {delayChildren: stagger(0.05)}
                                    }
                                }}
                                className="space-y-4">
                                <motion.li
                                    variants={{
                                        open: {
                                            y: 0,
                                            opacity: 1,
                                            transition: {
                                                y: {stiffness: 1000, velocity: -100}
                                            }
                                        },
                                        closed: {
                                            y: 20,
                                            opacity: 0,
                                            transition: {
                                                y: {stiffness: 1000}
                                            }
                                        }
                                    }}
                                >
                                    <MetaMaskConnectMenuItem/>
                                </motion.li>
                            </motion.ul>
                        </nav>
                    </div>

                    <div className="pb-4 border-b border-grey-02 mb-4">
                        <nav>
                            <motion.ul
                                initial="closed"
                                animate="open"
                                exit="closed"
                                variants={{
                                    open: {
                                        transition: {delayChildren: stagger(0.1)}
                                    },
                                    closed: {
                                        transition: {delayChildren: stagger(0.05)}
                                    }
                                }}
                                className="space-y-4">
                                <motion.li
                                    variants={{
                                        open: {
                                            y: 0,
                                            opacity: 1,
                                            transition: {
                                                y: {stiffness: 1000, velocity: -100}
                                            }
                                        },
                                        closed: {
                                            y: 20,
                                            opacity: 0,
                                            transition: {
                                                y: {stiffness: 1000}
                                            }
                                        }
                                    }}
                                >
                                    <LogoutMenuItem/>
                                </motion.li>
                            </motion.ul>
                        </nav>
                    </div>

                    <div className="mb-6">
                        <SocialComponent/>
                    </div>
                    <div className="flex flex-col space-y-2">
                        <nav>
                            <motion.ul
                                initial="closed"
                                animate="open"
                                exit="closed"
                                variants={{
                                    open: {
                                        transition: {delayChildren: stagger(0.1)}
                                    },
                                    closed: {
                                        transition: {delayChildren: stagger(0.05)}
                                    }
                                }}
                                className="space-y-4">
                                    <motion.li
                                        key={'datenschutz'}
                                        variants={{
                                            open: {
                                                y: 0,
                                                opacity: 1,
                                                transition: {
                                                    y: {velocity: -100}
                                                }
                                            },
                                            closed: {
                                                y: 20,
                                                opacity: 0,
                                                transition: {
                                                    y: {stiffness: 1000}
                                                }
                                            }
                                        }}
                                    >
                                        <Link href={'https://dreissigacker-wein.de/rechtliche-informationen/datenschutz-app/'} target={'_blank'} onClick={handleClose} scroll={false}>
                                            <span className="text-white text-[24px] uppercase flex-1 text-left">Datenschutz</span>
                                        </Link>
                                    </motion.li>
                                <motion.li
                                    key={'impressum'}
                                    variants={{
                                        open: {
                                            y: 0,
                                            opacity: 1,
                                            transition: {
                                                y: {stiffness: 1000, velocity: -100}
                                            }
                                        },
                                        closed: {
                                            y: 20,
                                            opacity: 0,
                                            transition: {
                                                y: {stiffness: 1000}
                                            }
                                        }
                                    }}
                                >
                                    <Link href={'https://dreissigacker-wein.de/rechtliche-informationen/impressum/'} target={'_blank'} onClick={handleClose} scroll={false}>
                                        <span className="text-white text-[24px] uppercase flex-1 text-left">Impressum</span>
                                    </Link>
                                </motion.li>
                            </motion.ul>
                        </nav>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}